/**
 * Project : workspace
 * File    : StoreThemeColorScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.store.color

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.parmartechnologies.business.feature.businessConfig.viewModel.BusinessConfigViewModel
import component.navigation.TopNavBar
import navigation.AppNavigator
import presentation.screens.business.store.color.component.ColorField

/**
 * Represents the store theme color screen class.
 */

class StoreThemeColorScreen {
    val viewModel = BusinessConfigViewModel()
    @Composable
    /**
 * Executes the content operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
    fun content(){

        Column {
            TopNavBar(
                "Theme Color",
                AppNavigator.shared().getNavigationParam(),
                onBackPress = {
                    AppNavigator.shared().goBack()
                }
            )
            LazyColumn(modifier = Modifier.fillMaxSize()) {
                item {
                    ColorField().Content(
                        "",
                        color = ""
                    )
                }
            }
        }
    }
}